export default __webpack_public_path__ + "static/media/spareParts.f4beaf45.png";